import moment from 'moment';
import firebase from '../config/fbConfig'

// Funcion para obtener el proveedor del usuario
export const getUserProvider = () => {
    return firebase.auth().currentUser.providerData;
}

export const getReduceFormattedData = data => {

    const objectData = {}

    for (const item of data) {
        if(objectData[item.created_at_formmatted] && objectData[item.created_at_formmatted].cookies) {
            objectData[item.created_at_formmatted] = {
                ...objectData[item.created_at_formmatted],
                cookies: objectData[item.created_at_formmatted].cookies + item.cookies,
            }
        } else {
            objectData[item.created_at_formmatted] = {
                cookies: item.cookies,
                user_id: item.user_id,
                created_at: item.created_at
            }
        }
    }

    const formattedDataCookies = Object.entries(objectData).map((item, index) => {
        return {
            name: item[0],
            cookies: item[1].cookies
        }
    })

    return formattedDataCookies

}

export const getCookiesTotal = data => {
    let cookies = 0;
    data.map(item => cookies += item.cookies);
    return cookies
}

export function underAgeValidate(birthday){

    let formattedBirthday = '';
    if(birthday.seconds) {
        formattedBirthday = moment(new Date(birthday.seconds * 1000)).format("LL")
    } else {
        formattedBirthday = birthday
    }
    console.log('formatted birthday', formattedBirthday)
	// it will accept two types of format yyyy-mm-dd and yyyy/mm/dd
	var optimizedBirthday = formattedBirthday.replace(/-/g, "/");

	//set date based on birthday at 01:00:00 hours GMT+0100 (CET)
	var myBirthday = new Date(optimizedBirthday);

	// set current day on 01:00:00 hours GMT+0100 (CET)
	var currentDate = new Date().toJSON().slice(0,10)+' 01:00:00';

	// calculate age comparing current date and borthday
	var myAge = ~~((Date.now(currentDate) - myBirthday) / (31557600000));


	if(myAge < 18) {
     	return false;
    }else{
	    return true;
	}

} 